import axios from 'axios'
import SettingCommon from './Common'

export default {
  components: {
    SettingCommon,
  },
  data() {
    return {
      title: '',
      endpointUrl: '',
      bulkUrl: '',
      tableData: [],
      tableLoading: false,
      dialog: {
        visible: false,
        isAlert: false,
        errorMessage: '',
        loading: false,
      },
      helpDialog: false,
      selection: [],
      form: {},
      refs: {
        table: '',
        form: '',
      },
    }
  },
  computed: {
    enabledNumber: function () {
      const num = this.tableData.reduce(function (acc, current, index, array) {
        if (current.enabled) {
          acc = acc + 1;
        }
        return acc;
      }, 0);
      return num;
    }
  },
  methods: {
    fetchData(search, cb) {
      this.tableLoading = true
      let url = this.endpointUrl
      let params = {}
      if (search !== undefined && search !== '') {
        params['search'] = search
      }
      if (this.$route.query.page !== undefined && this.$route.query.page > 0) {
        params['page'] = this.$route.query.page
      }
      axios.get(url, {
        params: params,
        maxContentLength: 200000
      }).then((response) => {
        this.tableData = response.data
        if (cb !== undefined) {
          cb()
        }
        this.tableLoading = false
      }).catch((error) => {
        console.log(error)
        this.tableLoading = false
      })
    },
    initDialog() {
      this.dialog = Object.assign({}, this.dialog, {
        isAlert: false,
        errorMessage: '',
        isEdit: false,
      })
    },
    onClickNewButton: function () {
      this.initDialog()
      this.dialog.title = this.title + 'の新規追加'
      this.dialog.visible = true
      this.dialog.isEdit = false
    },
    onClickEditButton: function (id) {
      axios.get(`${this.endpointUrl}${id}/`).then((response) => {
        this.form = response.data
        this.dialog.title = `${this.title}の編集`
        this.dialog.visible = true
        this.dialog.isEdit = true
      }).catch((error) => {
        if (error.response !== undefined) {
          if (error.response.status === 403) {
            let e = error.response.data
            console.log(e)
            if (Array.isArray(e)) {
              this.dialog.errorMessage = e.join(',')
            } else {
              if ('non_field_errors' in e) {
                this.dialog.errorMessage = e.non_field_errors.join(',')
              } else if ('detail' in e) {
                this.dialog.errorMessage = e.detail
              } else if (typeof e === 'object') {
                this.dialog.errorMessage = Object.values(e).join('')
              } else {
                this.dialog.errorMessage = e
              }
            }
            this.$notify.error({
              title: 'エラー',
              message: this.dialog.errorMessage,
              offset: 50
              })
          } else {
            this.dialog.visible = true
            this.dialog.isAlert = true
            this.dialog.loading = false
            this.dialog.errorMessage = '不明なエラーが発生しました。'
          }
        }
      })
    },
    onClickHelp: function () {
      this.helpDialog = true
    },
    handleSelectionChange(val) {
      this.selection = val
      console.log(this.selection)
    },
    handleRegisterCancel() {
      let ref = this.$refs[this.refs.form]
      this.initDialog()
      ref.resetFields()
    },
    handleRegister(evt, cb) {
      this.dialog.loading = true
      let ref = this.$refs[this.refs.form]
      let form = this.form
      ref.validate((valid) => {
        if (valid) {
          let request
          if (this.dialog.isEdit) {
            request = axios.put(`${this.endpointUrl}${form.id}/`, form)
          } else {
            request = axios.post(this.endpointUrl, form)
          }
          request.then((response) => {
            this.dialog.visible = false
            if (cb !== undefined) { // callbackが指定されている場合はfetchDataをしない
              this.initDialog()
              ref.resetFields()
              cb()
            } else {
              this.fetchData('', () => {
                this.initDialog()
                ref.resetFields()
              })
            }
          }).catch((error) => {
            if (error.response !== undefined) {
              this.dialog.isAlert = true
              this.dialog.loading = false
              if (error.response.status === 400) {
                let e = error.response.data
                console.log(e)
                if (Array.isArray(e)) {
                  this.dialog.errorMessage = e.join(',')
                } else {
                  if ('non_field_errors' in e) {
                    this.dialog.errorMessage = e.non_field_errors.join(',')
                  } else if ('detail' in e) {
                    this.dialog.errorMessage = e.detail
                  } else if (typeof e === 'object') {
                    this.dialog.errorMessage = Object.values(e).join('')
                  } else {
                    this.dialog.errorMessage = e
                  }
                }
              } else {
                this.dialog.errorMessage = '不明なエラーが発生しました。'
              }
            }
          })
          return true
        } else {
          this.dialog.loading = false
        }
      })
    },
  },
}